// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { ApiUrl } from '../../Constants/Weburl'; 

// export default function PrivacyPolicyView() {

//   const [content, setContent] = useState("");
//   const [loading, setLoading] = useState(true);

//   const adminToken = localStorage.getItem("adminToken");

//   console.log('adminToken', adminToken);

//   useEffect(() => {
//   const fetchPolicy = async () => {
//     try {
//       const res = await axios.get(`${ApiUrl}api/getprivacypolicy`, 
//           {
//           headers: { Authorization: `Bearer ${adminToken}` }
//         });

//       console.log("PRIVACY POLICY RESPONSE:", res.data);

//       setContent(res.data?.data?.content || "");
//     } catch (error) {
//       console.log("PRIVACY POLICY ERROR:", error.response?.data || error);
//     } finally {
//       setLoading(false);
//     }
//   };

  

//   fetchPolicy();
// }, []);

//   useEffect(() => {
//   const fetchPolicy = async () => {
//     try {
//       const res = await axios.get(`${ApiUrl}api/terms-of-use`, 
//           {
//           headers: { Authorization: `Bearer ${adminToken}` }
//         });

//       console.log("Terms of uses RESPONSE:", res.data);

//       setContent(res.data?.data?.content || "");
//     } catch (error) {
//       console.log("Terms of Uses ERROR:", error.response?.data || error);
//     } finally {
//       setLoading(false);
//     }
//   };

  

//   fetchPolicy();
// }, []);

//   if (loading) return <p>Loading...</p>;

//   return (
//     <div className="Privacy Policy">
//       <div
//         dangerouslySetInnerHTML={{
//           __html: content
//         }}
//       />
//     </div>
//   );
// }


import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ApiUrl } from '../../Constants/Weburl'; 


const PrivacyPolicyView = () => {

    const { type } = useParams();

    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    const isPrivacy = type === 'privacy-policy';

    useEffect(() => {
        getLegalContent();
    }, [type]);

    const getLegalContent = async () => {
        try {
            setLoading(true);
            setContent('');

            // Existing backend APIs use pannu
            const endpoint = isPrivacy
                ? 'privacy-policy'
                : 'terms-of-use';

            const res = await axios.get(
                `${ApiUrl}api/${endpoint}`
            );

            console.log("privacy policy", res.data);
            console.log("CONTENT:", res.data);

            setContent(res.data || '');

        } catch (error) {
            console.log('Legal content error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="legal-content">

            {/* <h1>
                {isPrivacy ? 'Privacy Policy' : 'Terms of Use'}
            </h1> */}

            {loading ? (
                <p>Loading...</p>
            ) : (
                <div
                    dangerouslySetInnerHTML={{
                        __html: content
                    }}
                />
            )}

        </div>
    );
};

export default PrivacyPolicyView;